// --- Track Header ---
export const TRACK_HEADER_MIN_WIDTH = 38; // hide label
export const TRACK_HEADER_MAX_WIDTH = 350;
export const TRACK_HEADER_DEFAULT_WIDTH = 120;

// --- Track ---
export const CANVAS_TRACK_MARGIN = 10;
